window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.name === 'AbortError' && /play\(\) request was interrupted/.test(event.reason?.message || '')) {
    event.preventDefault();
  }
});

(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const targets = document.querySelectorAll('deferred-media[data-autoplay-on-view]');
  if (!targets.length) return;

  function spinnerWrapper(mediaEl) {
    return mediaEl.querySelector('.deferred-media__loading-spinner');
  }
  function innerSpinner(mediaEl) {
    return spinnerWrapper(mediaEl)?.querySelector('.loading__spinner');
  }

  const spinnerTimers = new WeakMap();
  const shouldBePlaying = new WeakSet();

  function showSpinner(mediaEl) {
    spinnerWrapper(mediaEl)?.classList.add('is-visible');
    innerSpinner(mediaEl)?.classList.remove('hidden');
    clearTimeout(spinnerTimers.get(mediaEl));
    spinnerTimers.set(mediaEl, setTimeout(() => hideSpinner(mediaEl), 15000));
  }
  function hideSpinner(mediaEl) {
    spinnerWrapper(mediaEl)?.classList.remove('is-visible');
    clearTimeout(spinnerTimers.get(mediaEl));
  }

  function setupVideo(mediaEl, video) {
    video.muted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');

    if (typeof video.requestVideoFrameCallback === 'function') {
      let firstFrame = true;
      let stallTimer = null;
      const armStallTimer = () => {
        clearTimeout(stallTimer);
        stallTimer = setTimeout(() => {
          if (shouldBePlaying.has(mediaEl)) showSpinner(mediaEl);
        }, 600);
      };
      const onFrame = () => {
        if (firstFrame) {
          firstFrame = false;
          video.removeAttribute('poster');
        }
        hideSpinner(mediaEl);
        armStallTimer();
        video.requestVideoFrameCallback(onFrame);
      };
      video.requestVideoFrameCallback(onFrame);
      armStallTimer();
    } else {
      let lastTime = 0;
      let lastCheck = performance.now();
      let skipNext = 0;

      setInterval(() => {
        if (video.ended) return;
        if (video.paused) {
          if (shouldBePlaying.has(mediaEl)) showSpinner(mediaEl);
          return;
        }
        const now = performance.now();
        const wallDelta = (now - lastCheck) / 1000;
        const videoDelta = video.currentTime - lastTime;
        const isLoopRestart = video.currentTime < lastTime && lastTime > (video.duration || Infinity) - 1;
        lastCheck = now;
        lastTime = video.currentTime;

        if (isLoopRestart) { skipNext = 1; return; }
        if (skipNext > 0) { skipNext--; return; }

        if (videoDelta < wallDelta * 0.7) {
          showSpinner(mediaEl);
        } else {
          hideSpinner(mediaEl);
        }
      }, 400);
    }

    video.addEventListener('pause', () => {
      if (document.body.classList.contains('overflow-hidden')) return;
      if (!shouldBePlaying.has(mediaEl)) return;
      setTimeout(() => {
        if (video.paused) playVideo(mediaEl, video);
      }, 300);
    });
  }

  function playVideo(mediaEl, video) {
    if (!video.paused && video.readyState >= 3) return;
    if (video.readyState < 3) showSpinner(mediaEl);
    video.play().catch((err) => {
      if (err.name !== 'AbortError') hideSpinner(mediaEl);
    });
  }

  const debounceTimers = new WeakMap();
  function debounced(mediaEl, fn) {
    clearTimeout(debounceTimers.get(mediaEl));
    debounceTimers.set(mediaEl, setTimeout(fn, 150));
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const mediaEl = entry.target;
        const isIntersecting = entry.isIntersecting;

        if (isIntersecting) shouldBePlaying.add(mediaEl);
        else shouldBePlaying.delete(mediaEl);

        debounced(mediaEl, () => {
          let video = mediaEl.querySelector('video');

          if (isIntersecting) {
            if (video) {
              playVideo(mediaEl, video);
            } else {
              showSpinner(mediaEl);
              mediaEl.querySelector('.deferred-media__poster')?.click();
              video = mediaEl.querySelector('video');
              if (video) {
                setupVideo(mediaEl, video);
                playVideo(mediaEl, video);
              }
            }
          } else if (video) {
            video.pause();
          }
        });
      });
    },
    { threshold: 0.6 }
  );

  targets.forEach((el) => observer.observe(el));

  document.body.addEventListener('modalClosed', () => {
    targets.forEach((mediaEl) => {
      if (!shouldBePlaying.has(mediaEl)) return;
      const video = mediaEl.querySelector('video');
      if (video && video.paused) playVideo(mediaEl, video);
    });
  });
})();